<template>
  <v-media class="slogan" xAlign="c" yAlign="t" :halfFilling="false">
    <template v-slot:left>
      <picture class="slogan-img">
        <source srcset="@/assets/img/screen.webp" type="image/webp" />
        <img
          class="slogan-img"
          src="@/assets/img/screen.png"
          alt="Sovtes screenshot of web program"
        />
      </picture>
    </template>

    <template v-slot:right>
      <p class="slogan-content text-md">
        <span>{{ dic.sectionSlogan.msg1 }}</span>
        <br />
        <span>{{ dic.brand }} - {{ dic.sectionSlogan.msg2 }}</span>
      </p>
    </template>
  </v-media>
</template>

<script>
import VMedia from '@/components/ui/VMedia'
export default {
  components: {
    VMedia,
  },
  computed: {
    currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
.slogan {
  justify-content: center;
  align-items: center;
  transform: scaleY(1.11);
  padding: 0 20px;
  box-sizing: border-box;
  width: 100%;

  background: linear-gradient(
    0deg,
    #021759 0%,
    #021759 95%,
    transparent 95%,
    transparent 100%
  );

  &-img {
    min-height: 100%;
    max-width: 380px;
  }

  &-content {
    color: #ffffff;
    font-weight: 300;
    padding: 0 30px;

    max-width: 400px;

    span {
      line-height: 1.3;
      margin: 5px 0;
      display: inline-block;
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .slogan {
    flex-wrap: wrap;

    &-img {
      max-width: 340px;
    }

    &-content {
      padding: 20px 10px;
      text-align: center;

      max-width: 400px;

      span {
        line-height: 1.2;
        margin: 5px 0;
        display: inline-block;
      }
    }
  }
}

@media (max-width: 375px), (max-width: 414px) {
  .slogan {
    flex-wrap: wrap;

    &-img {
      max-width: 240px;
    }

    &-content {
      padding: 20px 10px;
      text-align: center;

      max-width: 400px;

      span {
        line-height: 1.2;
        margin: 5px 0;
        display: inline-block;
      }
    }
  }
}
</style>
